<template>
  <div>
    <template v-for="(item,index) in dataBenefits">
      <template v-if="item.used && ((item.code_eshop && item.code_eshop_used) || (item.code_store && item.code_store_used))">
        <v-card :key="index" class="mb-4" style="background: #000;" disabled>
          <div class="d-flex" style="cursor: pointer; border: 5px solid #000;">
            <div 
              style="width: 70%;  background: #FFF; font-size: 18px; font-weight: 600"
              class="d-flex align-center justify-center text-center pa-5"
            >
              {{ item.name }}
            </div>
            <div 
              style="width: 30%; background-size: cover;"
              :style="{ backgroundImage: 'url(' +background+ ')'}"
              class="d-flex align-center justify-center text-center"
            >
              
              <img v-if="item.sub_category_photo_url" :src="item.sub_category_photo_url" width="64px"/>
              <img v-else :src="require('@/assets/images/icon-birthday.png')" width="64px"/>
            </div>
          </div>
        </v-card>
      </template>
      <template v-else>
        <v-card :key="index" class="mb-4">
          <div class="d-flex" style="cursor: pointer; border: 5px solid #000; min-height: 100px;" @click="onModalBenefit(item)">
            <div 
              style="width: 70%;  background: #FFF; font-size: 18px; font-weight: 600"
              class="d-flex align-center justify-center text-center pa-5"
            >
              {{ item.name }}
            </div>
            <div 
              style="width: 30%; background-size: cover;"
              :style="{ backgroundImage: 'url(' +background+ ')'}"
              class="d-flex align-center justify-center text-center"
            >
              
              <img v-if="item.sub_category_photo_url" :src="item.sub_category_photo_url" width="64px"/>
              <img v-else :src="require('@/assets/images/icon-birthday.png')" width="64px"/>
            </div>
          </div>
        </v-card>
      </template>
    </template>

    <v-dialog width="350px" v-model="showSelectBenefitModal">
      <template v-if="showSelectBenefitModal">
        <BenefitModal
          v-model="selectedBenefit"
          @next="onNextStep"
          @close="onCloseModal"
          @success="onRedeemSuccess"
        ></BenefitModal>
      </template>
    </v-dialog>

  </div>
</template>

<script>
  import axios from "axios";
  import BenefitModal from "./BenefitModal.vue"

  export default {
    props:['dataBenefits','memberType'],
    components:{
      BenefitModal
    },
    data() {
      return {
        showSelectBenefitModal: false,
        benefitDetails: '',
        limit: 50,
        offset: 0,
        background: null,
        selectedBenefit: null,
      }
    },
    mounted() {
      if(this.memberType === 'silver'){
        this.background = require(`../../assets/images/bg-redeem-vip.png`);
      } else if(this.memberType === 'gold') {
        this.background = require(`../../assets/images/bg-redeem-gold.png`);
      } else {
        this.background = require(`../../assets/images/bg-redeem-vip.png`);
      }
    },
    methods: { 
      onModalBenefit(item) {
        this.showSelectBenefitModal = true;
        this.selectedBenefit = item;
      },
      onRedeemSuccess() {
        this.$emit('redeemSuccess');
      },
      onNextStep() {
        this.selectedBenefit = null;
      },
      onCloseModal() {
        this.selectedBenefit = null;
        this.showSelectBenefitModal = false
      }
    }
    
  }
</script>

<style lang="scss" scoped>

</style>